export const AddressCategories = {
  INFORMATIONS: 'informations',
  SERVICES: 'services',
  DESCRIPTION: 'description',
  PHOTOS: 'photos',
};

export const NonRestrictedAddressCategories = [
  AddressCategories.INFORMATIONS,
  AddressCategories.SERVICES,
];
export const RestrictedAddressCategories = [
  ...NonRestrictedAddressCategories,
  AddressCategories.PHOTOS,
  AddressCategories.DESCRIPTION,
];
